import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { colors } from '../../../../../../../../../colorVars';
import IncrementButton from '../../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import { Body2 } from '../../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../../alertFormClass';
import style from './AddFilter.module.css';

export const AddFilter = observer(() => {
  const form = useAlertFormStore();
  const [filterSelection, setFilterSelection] = useState();

  return (
    <div className={style.container}>
      <Body2 color={colors.lightGrey} fontWeight={700}>
        Setup Filters
      </Body2>
      <div className={style.selectAndButton}>
        <select
          className={style.select}
          value={filterSelection}
          onChange={({ target }) => setFilterSelection(target.value)}
        >
          <option value="default">Select a filter...</option>
          <option value="FTFC">FTFC</option>
          {/* <option value="TIME_OF_DAY">Time of Day</option>
          <option value="PRICE_INTERSECTS_FIRST_CANDLE">
            Price Intersects First Candle
          </option> */}
        </select>
        <IncrementButton
          paddingPercent={10}
          buttonWidth="24px"
          width={18}
          color={colors.lightGrey}
          backgroundColor={colors.blue}
          stroke={2}
          handleClick={() => {
            if (!form.setupFilters[filterSelection])
              form.addSetupFilter(filterSelection);
          }}
          margin="0 0 0 5px"
        />
      </div>
    </div>
  );
});
